import { render, staticRenderFns } from "./checkboxRenderer.vue?vue&type=template&id=8d82a822&"
import script from "./checkboxRenderer.vue?vue&type=script&lang=js&"
export * from "./checkboxRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d82a822')) {
      api.createRecord('8d82a822', component.options)
    } else {
      api.reload('8d82a822', component.options)
    }
    module.hot.accept("./checkboxRenderer.vue?vue&type=template&id=8d82a822&", function () {
      api.rerender('8d82a822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/generic/list/renderer/checkboxRenderer.vue"
export default component.exports